import { Instance } from "../axios/instance";

export async function login(payload: any) {
  const response = await Instance.post("/Authentication/Login", payload);
  return response;
}
